import { useEffect, useState } from 'react';

import { isMobile } from '@common/device-manager';
import { useCatalogProductIdParams, usePdpBaseInfo, useProductThumbnail } from '@domains/pdp-common';

import { image_fit_contain_shop_id_list } from '../constants/image_fit_contain_shop_id_list';
import { useGalleryUBL } from '../log/useGalleryUBL';
import { useFirstImageHeightRatio } from './useFirstImageHeightRatio';

export const useGalleryService = () => {
  const params = useCatalogProductIdParams();
  const { product, shop } = usePdpBaseInfo(params);
  const { image_list } = useProductThumbnail();
  const { first_image_height_ratio } = useFirstImageHeightRatio({ image_list });
  const { impressionMainImageUBL } = useGalleryUBL();

  const [is_mobile, setIsMobile] = useState(true);
  const [current_index, setCurrentIndex] = useState(0);

  const is_fit_contain = image_fit_contain_shop_id_list.has(shop.id);

  useEffect(() => {
    if (!isMobile()) {
      setIsMobile(false);
    }
  }, []);

  useEffect(() => {
    if (image_list.length) {
      impressionMainImageUBL(product?.id, image_list[0].id ?? '', current_index);
    }
  }, [image_list, current_index]);

  const handleChangeIndex = (index: number) => {
    setCurrentIndex(index);
  };

  return {
    handleChangeIndex,
    image_list,
    current_index,
    is_button_hidden: is_mobile || image_list.length < 2,
    is_dots_hidden: image_list.length < 2,
    first_image_height_ratio,
    is_fit_contain,
  };
};
